'use client';

import type { PostGridProps } from '@routeroyal/theme-core';
import { StoneInvestmentPostCard } from './PostCard';

/**
 * Stone Investment Post Grid
 * 
 * Grid layout for posts with editorial styling
 */
export function StoneInvestmentPostGrid({ 
  posts, 
  variant: _variant = 'grid',
  columns = 3,
  cardVariant = 'default',
  showExcerpt = true,
  showCategory = true,
  showAuthor = false,
  emptyMessage = 'No articles found',
  locale = 'en',
  basePath = '/news',
  className = '',
  messages: _messages,
}: PostGridProps) {
  if (posts.length === 0) {
    return (
      <div className={`text-center py-16 ${className}`}>
        <p 
          className="text-[var(--color-text-muted)]"
          style={{ fontFamily: "'DM Sans', sans-serif" }}
        >
          {emptyMessage}
        </p>
      </div>
    );
  }

  const gridCols = {
    1: 'grid-cols-1',
    2: 'grid-cols-1 md:grid-cols-2',
    3: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-3',
    4: 'grid-cols-1 md:grid-cols-2 lg:grid-cols-4',
  };

  return (
    <div className={`grid ${gridCols[columns]} gap-8 lg:gap-10 ${className}`}>
      {posts.map((post) => (
        <StoneInvestmentPostCard
          key={post.id}
          post={post}
          variant={cardVariant}
          showExcerpt={showExcerpt}
          showCategory={showCategory}
          showAuthor={showAuthor}
          locale={locale}
          basePath={basePath}
        />
      ))}
    </div>
  );
}
